import { Button, Col, Form, Input, Modal, notification, Popconfirm, Row, Spin, Switch, Table } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined, UpSquareOutlined, DownSquareOutlined, } from '@ant-design/icons';
import { useEffect, useState } from "react";
import '../style/MeasurementsTypes.scss'
import waist from '../../../../../assets/icons/waist.png'
import arms from '../../../../../assets/icons/arms.png'
import chest from '../../../../../assets/icons/chest.png'
import weight from '../../../../../assets/icons/weight.png'
import abdomen from '../../../../../assets/icons/abdomen.png'
import { AddMeasurementsTypes } from "../AddMeasurementsTypes";
import { listOfMeasurementTypesApi, updateMeasurementTypeApi } from "../../../../../config/Api";
import { API_ERR_MESSAGE, MEASUREMENT_TYPE_IMAGE_BASE_URL } from "../../../../../config/constant";
export const MeasurementsTypes = () => {

    const [dataSource, setDataSource] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [isActive, setIsActive] = useState(false)
    const [buttonName, setButtonName] = useState('ADD')
    const [measurementTypeData, setMeasurementTypeData] = useState()
    const [editMeasurementsTypeRecord, setEditMeasurementsTypeRecord] = useState()
    const [loading, setLoading] = useState(false)

    const [isModalVisible, setIsModalVisible] = useState(false)


    // get the list of alll available plans 
    const getListOfMeasurementTypes = () => {
        setLoading(true)

        listOfMeasurementTypesApi()
            .then((res) => {
                if (res.status === 200) {
                    setDataSource(res.data.data);
                    setDisplayData(res.data.data);
                }
                setLoading(false)
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
            });
    }
    useEffect(() => {
        getListOfMeasurementTypes()
    }, [])
    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const onChange = (checked, data) => {

        const formData = new FormData()
        formData.append('name', data.name)
        formData.append('image', null)
        formData.append('isDecimal', data.isDecimal)
        formData.append('status', checked)
        // remove measurements_type_id fields from objects
        data?.measurements_type_unit?.map((element) => (
            delete element.measurements_type_id,
            delete element.created_at,
            delete element.updated_at,
            delete element?.unit?.created_at,
            delete element?.unit?.updated_at
        )
        )

        formData.append('measurements_type_unit', JSON.stringify(data.measurements_type_unit))
        updateMeasurementTypeApi(data.id, formData)
            .then((res) => {
                if (res.status == 200) {
                    notification.success({
                        message: "Measurement Type Update successfully",
                    });
                    getListOfMeasurementTypes()
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });

    };


    // filter data according to user search input 
    useEffect(() => {
        filterMeasurementType(measurementTypeData);
    }, [measurementTypeData]);

    // filter Measurement Types 
    const filterMeasurementType = (data) => {
        if (!data) {
            setDisplayData(dataSource);
        } else {
            let tmp = [];
            dataSource.length > 0 && dataSource.forEach((element) => {
                if (element.name.toUpperCase().indexOf(data.toUpperCase()) !== -1) {
                    tmp.push(element);
                }
            });
            setDisplayData(tmp);
        }
    };


    const editMeasurementsType = (data) => {
        setButtonName("UPDATE")
        setEditMeasurementsTypeRecord(data);
        setIsModalVisible(true)
    }
    const addMeasurementsType = () => {
        setEditMeasurementsTypeRecord();
        setIsModalVisible(true);
        setButtonName('SAVE')
    }

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'Image',
            dataIndex: 'image',
            key: 'image',
            render: (text) => <img src={MEASUREMENT_TYPE_IMAGE_BASE_URL + text} width={50} alt="Measurement Image" />,
        },
        {
            title: 'Decimal',
            dataIndex: 'isDecimal',
            key: 'isDecimal',
            render: (text) => <p>{text ? 'Enable' : 'Disable'}</p>,
            filters: [
                { text: "Enable", value: true },
                { text: "Disable", value: false },
            ],
            onFilter: (value, record) => record.isDecimal == value,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, data) => <>
                {/* <Switch onChange={(e) => onChange(text, data)} /> */}
                <Switch checked={text} onChange={(e) => { setIsActive(!isActive); onChange(e, data) }} />
            </>,
            filters: [
                { text: "Active", value: true },
                { text: "DeActive", value: false },
            ],
            onFilter: (value, record) => record.status == value,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <div className="action align-self-center">
                    <Button icon={<EditOutlined />} onClick={(e) => editMeasurementsType(record)} className="me-2" />
                    <Popconfirm title="Sure to delete?" >
                        <Button icon={<DeleteOutlined />} />
                    </Popconfirm>
                </div>
            ),
        },
    ];
    const data = [
        {
            id: '1',
            name: 'Waist',
            status: true,
            image: waist,
        },
        {
            id: '2',
            name: 'Weight',
            status: false,
            image: weight,
        },
        {
            id: '3',
            name: 'Chest',
            status: true,
            image: chest,
        },
        {
            id: '4',
            name: 'Abdomen',
            status: true,
            image: abdomen,
        },
        {
            id: '5',
            name: 'Arms',
            status: true,
            image: arms,
        }
    ];

    const [form] = Form.useForm();

    const onFinish = (values) => {
        // console.log(values);
    };
    const resetData = () => {
        form.resetFields()
    };
    const expandedRowRender = (record) => {
        const innercolumns = [
            {
                title: 'Unit',
                dataIndex: 'measurements_type_unit',
                render: (_, record) => <p className="mb-0">{record?.unit?.name}</p>
            },
            {
                title: 'Min Value',
                dataIndex: 'min_value',
            },
            {
                title: 'Max Value',
                dataIndex: 'max_value',
            },
        ]
        return (
            <Table
                columns={innercolumns}
                rowKey="id"
                dataSource={record.measurements_type_unit || []}
                pagination={false}
            />
        )
    };

    return (
        <div className="MeasurementsTypes">
            <Row >
                <Col xl={14} className="my-3">
                    <Button htmlType="submit"
                        className="submit-button  border-0 rounded ms-2"
                        icon={<PlusOutlined
                            style={{ fontSize: "1.2rem" }}
                        />}
                        onClick={() => addMeasurementsType()}
                    >
                        Add
                    </Button>
                </Col>
                <Col xl={4} className="text-end align-self-center">
                    <h6>Total :  {displayData.length > 0 ? displayData.length : 0}  </h6>
                </Col>
                <Col xl={6} className="align-self-center">
                    <Input.Search placeholder="Search Measurement Types"
                        onChange={(e) => { filterMeasurementType(e.target.value); setMeasurementTypeData(e.target.value) }}
                        className="p-2" />
                </Col>
            </Row>
            <Spin spinning={loading} className="spinner-code">
            <Row>
                <Table
                    columns={columns}
                    dataSource={displayData}
                    // pagination={false}
                    scroll={{ x: "max-content" }}
                    className="w-100"
                    rowKey="id"
                    expandIcon={({ expanded, onExpand, record }) =>
                        expanded ? (
                            <UpSquareOutlined onClick={(e) => onExpand(record, e)} />
                        ) : (
                            <DownSquareOutlined onClick={(e) => onExpand(record, e)} />
                        )
                    }
                    expandable={{
                        expandedRowRender: ((record) => expandedRowRender(record)),
                        // expandIconColumnIndex: 10,
                        // rowExpandable: (record) => console.log(record),
                        rowExpandable: (record) => record.id !== 'Not Expandable'
                    }}
                />
            </Row>
            </Spin>
            <Modal
                open={isModalVisible}
                footer={null}
                width={1000}
                className="AddMeasurementsTypes rounded"
                onOk={handleOk} onCancel={handleCancel}
            >
                <AddMeasurementsTypes
                    getListOfMeasurementTypes={getListOfMeasurementTypes}
                    editMeasurementsTypeRecord={editMeasurementsTypeRecord}
                    setIsModalVisible={setIsModalVisible}
                    setButtonName={setButtonName}
                    buttonName={buttonName}
                />
            </Modal>
        </div>
    )
}
